<template>
  <div v-if="screenData" class="sub-view analysis-zone">
    <div :class="['sub-view-wrapper', activeAside && 'opened']">
      <div class="sub-view-gabarit">
        <div class="header-box">
          <h4>{{ $t('sections.synthesis') }}</h4>
        </div>
        <Parameters v-if="study" :study="study" :desktop="true" class="thumb" />
        <Filters />
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.synthesisResults') }}</h5>
          </template>
          <template #body>
            <TargetSynthesis :data="screenData" />
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.synthesisCollaboratorOrigins') }}</h5>
          </template>
          <template #body>
            <CollaboratorOrigins :data="screenData" />
          </template>
        </AnalysisSection>
      </div>
      <FooterSection v-if="isDesktop" class="footer-section" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Analysis from './AnalysisMixin';
import Parameters from '@/components/Study/Parameters';
import TargetSynthesis from '@/components/Analysis/Synthesis/TargetSynthesis';
import CollaboratorOrigins from '@/components/Analysis/Synthesis/CollaboratorOrigins';
import FooterSection from '@/components/Footer';

export default {
  components: {
    Parameters,
    TargetSynthesis,
    CollaboratorOrigins,
    FooterSection,
  },

  mixins: [Analysis],

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
    }),
  },
};
</script>
